import styled from "styled-components";

export const RemoveDiscontinuationBannerContent = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.small};
  color: ${({ theme }) => theme.colors.darkGrey};
`;
